const MAX_DIMENSION = 1800;
const TARGET_BYTES = 850 * 1024;

async function loadImage(file) {
  const url = URL.createObjectURL(file);

  try {
    const image = new Image();
    image.src = url;

    if (image.decode) {
      await image.decode();
    } else {
      await new Promise((resolve, reject) => {
        image.onload = resolve;
        image.onerror = () => reject(new Error('The image could not be opened.'));
      });
    }

    return image;
  } finally {
    URL.revokeObjectURL(url);
  }
}

export async function compressImage(file) {
  if (!file || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
    throw new Error('Choose a JPG, PNG, or WebP image.');
  }

  const image = await loadImage(file);
  const scale = Math.min(1, MAX_DIMENSION / Math.max(image.naturalWidth, image.naturalHeight));
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
  canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
  const context = canvas.getContext('2d');
  if (!context) throw new Error('This browser could not prepare the image.');
  context.drawImage(image, 0, 0, canvas.width, canvas.height);

  const encode = (quality) => new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => blob ? resolve(blob) : reject(new Error('Image compression failed.')),
      'image/webp',
      quality
    );
  });

  let blob = await encode(0.82);
  if (blob.size > TARGET_BYTES) blob = await encode(0.65);
  if (blob.size >= file.size) return file;

  const name = file.name.replace(/\.[^.]+$/, '') + '.webp';
  return new File([blob], name, { type: 'image/webp', lastModified: Date.now() });
}